import { render, staticRenderFns } from "./CompanyEnableNewMenu.vue?vue&type=template&id=6c060f6a&scoped=true"
import script from "./CompanyEnableNewMenu.vue?vue&type=script&lang=js"
export * from "./CompanyEnableNewMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyEnableNewMenu.vue?vue&type=style&index=0&id=6c060f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c060f6a",
  null
  
)

export default component.exports